import React, { Component } from 'react';  
import { EventRegister } from 'react-native-event-listeners'
import store from "../config/config.json"
import ReactPixel from 'react-facebook-pixel';

const advancedMatching = { em: 'ee_umar@yahoo.com' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: true, // enable logs
};

export default class MainComponent extends Component {  

    constructor(props){
        super(props)
        if(store.pixelId != undefined || store.pixelId != ""){
            ReactPixel.init(store.pixelId, advancedMatching, options);
            ReactPixel.pageView();
		}
    }

    componentWillMount() {
        this.listener = EventRegister.addEventListener('languageEvent', (data) => {
            this.setState({updated: true})
        })
    }
    
    componentWillUnmount() {
        EventRegister.removeEventListener(this.listener)
    }

    calculateTotalOrderPrice(orderData, store, deliveryData, promoData)
    {
        var ordersData = []
        var selectedIds = {}
        var taxCharges  = 0
        var ordersCount = 0
        var totalPrice  = 0
        var deliveryCharges = 0
        var promoDiscount = 0
        var offersDiscount = 0
        var reset = false;

        if(orderData != undefined && orderData.length > 0)
		{
			orderData.map(item => {	
                
                if(item.mainItem == undefined || item.categoryId == undefined)
                {
                    reset = true
                }
                					
				item.taxPrice 	= 0
				item.itemPrice = +item.price
                ordersCount += item.counter

				item.addons.map(addon => {
					addon.modifiers.map(modifier => {
						item.itemPrice += +modifier.price
					})
				})

                item.itemPrice = item.itemPrice * item.counter
				if(item.disableTax != undefined && item.disableTax == true){
				}else{
						// Two tax cases
					if(item.tax == 0){
						// apply store tax.
						item.taxPrice += +store.tax * (item.itemPrice)/100
					}else{
						item.taxPrice += +item.tax * (item.itemPrice)/100
					}
				}
				
                item.totalPrice = item.itemPrice + item.taxPrice
                
                var discountPrice = 0
                if(item.offerData != undefined)
                {
                    if (item.offerData.type == 10) // Fixed price
                        discountPrice = this.state.offerData.amount

                    if (item.offerData.type == 11) // percentage
                        discountPrice = (+item.offerData.amount * item.totalPrice/100)
                    
                    if(discountPrice < 0)
                        discountPrice = 0
                    
                    item.offerDiscount = discountPrice
                    offersDiscount += discountPrice
                }

				taxCharges = taxCharges + item.taxPrice
                totalPrice = totalPrice + item.itemPrice
                selectedIds[item.mainItem.key] = item.counter
				ordersData.push(item)
			})
        }
        

		if(deliveryData != undefined && deliveryData.area != undefined && deliveryData.area != "")
		{
            deliveryCharges = +deliveryData.area.fee 
            if(deliveryCharges == undefined)
                deliveryCharges = 0 
		}

		if(promoData != undefined)
		{		
			promoDiscount = this.calculatePromoDiscount(promoData, deliveryData, totalPrice + taxCharges, orderData, store)
		}

        var mainTotalPrice = totalPrice + taxCharges + deliveryCharges - promoDiscount - offersDiscount
		if(mainTotalPrice < 0)
            mainTotalPrice = 0
            
        return {
            reset : reset,
            ordersCount : ordersCount,
            mainTotalPrice : mainTotalPrice,
            itemsPrice     : totalPrice,
            taxCharges     : taxCharges,
            deliveryCharges: deliveryCharges,
            promoDiscount : promoDiscount,
            selectedIds : selectedIds,
            ordersData : ordersData,
            offersDiscount : offersDiscount
        }
    }

    calculatePromoDiscount(mData, mDeliveryData, totalPrice, productData, store)
    {
        var promoDiscount = 0
        var catDataFound = true
        var prodDataFound = true

        var promoProductsData = []

        if(productData != undefined && mData.productsList != undefined && mData.productsList.length > 0)
        {
            prodDataFound = false
            mData.productsList.forEach(item => 
            {
                productData.forEach(productItem => 
                {
                    if(productItem.key == item.key)
                    {
                        prodDataFound = true
                        promoProductsData.push(productItem)
                    }
                })
            })
        }
        
        if(productData != undefined && mData.categoriesList != undefined && mData.categoriesList.length > 0)
        {
            catDataFound = false
            mData.categoriesList.forEach(item => 
                {
                    productData.forEach(productItem => 
                    {
                        if(productItem.categoryId == item.key)
                        {
                            catDataFound = true
                            promoProductsData.push(productItem)
                        }
                    })
                })
        }
    
        let usageCount = mData.usageLimit - mData.usageCount
            // Need to check if it fulfills the conditions.
        let startDate 	  = (mData.startDate == undefined || mData.startDate == "") ? new Date().getTime() : mData.startDate
        let currentDate   = new Date().getTime()
        let endDate   	  = (mData.endDate == undefined || mData.startDate == "") ? new Date().getTime() : mData.endDate

        if (mData.status == true && usageCount > 0 
            && mData.minimumPurchase <= totalPrice
            && currentDate >= startDate
            && currentDate <= endDate	
            && (catDataFound || prodDataFound)	 			
            )
        {
            if(mData.freeDelivery){                
                if(mDeliveryData != undefined && mDeliveryData.area != undefined)
                    promoDiscount = +mDeliveryData.area.fee
            }
            else if (promoProductsData.length > 0)
            {
                // Calculate total price of products.
                var totalPrice = 0
                var taxCharges = 0

                promoProductsData.map(item => {	
                    var itemPrice = +item.price
					item.addons.map(addon => {
						addon.modifiers.map(modifier => {
							itemPrice += +modifier.price
						})
					})
					if(item.disableTax != undefined && item.disableTax == true){
					}else{
						// Two tax cases
						if(item.tax == 0){
							// apply store tax.
							taxCharges += +store.tax * (itemPrice * item.counter)/100
						}else{
							taxCharges += +item.tax * (itemPrice * item.counter)/100
						}
					}
                    totalPrice += itemPrice * item.counter
                }) 

                totalPrice = totalPrice + taxCharges

                if(+mData.type == 10) // is fixed
                    promoDiscount = +mData.amount
                else
                    promoDiscount = +mData.amount * totalPrice/100           
            }
            else
            {
                if(+mData.type == 10) // is fixed
                    promoDiscount = +mData.amount
                else
                    promoDiscount = +mData.amount * totalPrice/100
            }
        }
        else{
        }

        if(promoDiscount < totalPrice)
           return promoDiscount
        else
            return totalPrice
    }

    callPixelEvent(event, data)
    {
        console.log("calling event" + event)
		if(store.pixelId != undefined || store.pixelId != ""){
            ReactPixel.init(store.pixelId, advancedMatching, options);
            ReactPixel.trackCustom(event, data);
		}

    }
}